import update from 'immutability-helper'
import { deleteItemById, updateItem } from '../../helpers/reducerHelpers'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_RIGHTS,
  GET_RIGHTS_SUCCESS,
  GET_RIGHTS_FAILURE,
  CLEAR_RIGHTS,
  GET_RIGHT,
  GET_RIGHT_SUCCESS,
  GET_RIGHT_FAILURE,
  CLEAR_RIGHT,
  CREATE_RIGHT,
  CREATE_RIGHT_SUCCESS,
  CREATE_RIGHT_FAILURE,
  CLEAR_CREATE_RIGHT,
  UPDATE_RIGHT,
  UPDATE_RIGHT_SUCCESS,
  UPDATE_RIGHT_FAILURE,
  CLEAR_UPDATE_RIGHT,
  DELETE_RIGHT,
  DELETE_RIGHT_SUCCESS,
  DELETE_RIGHT_FAILURE,
  CLEAR_DELETE_RIGHT,
  GET_RIGHT_SUGGESTED_CHANGES,
  GET_RIGHT_SUGGESTED_CHANGES_SUCCESS,
  GET_RIGHT_SUGGESTED_CHANGES_FAILURE,
  CLEAR_RIGHT_SUGGESTED_CHANGES,
  APPLY_RIGHT_SUGGESTED_CHANGES,
  APPLY_RIGHT_SUGGESTED_CHANGES_SUCCESS,
  APPLY_RIGHT_SUGGESTED_CHANGES_FAILURE,
  CLEAR_APPLY_RIGHT_SUGGESTED_CHANGES,
  GET_PARTNERBRAIN_HISTORY,
  GET_PARTNERBRAIN_HISTORY_SUCCESS,
  GET_PARTNERBRAIN_HISTORY_FAILURE,
  CLEAR_PARTNERBRAIN_HISTORY,
  GET_RIGHT_SOCIAL_POSTS,
  GET_RIGHT_SOCIAL_POSTS_SUCCESS,
  GET_RIGHT_SOCIAL_POSTS_FAILURE,
  CLEAR_RIGHT_SOCIAL_POSTS,
  SET_RIGHT_UPLOAD_AD_DATA,
  CLEAR_RIGHT_UPLOAD_AD_DATA
} from '../actions/rights'

import {
  INITIAL_CREATE_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_GET_RESULTS_PAGING_REDUCER,
  INITIAL_GET_RESULTS_REDUCER,
  INITIAL_UPDATE_REDUCER
} from '../../constants/reducer'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'

const INITIAL_RIGHT_UPLOAD_AD_DATA_REDUCER = {
  campaign: {},
  lineItem: {}
}

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  rightsList: INITIAL_GET_RESULTS_REDUCER,
  right: {
    ...INITIAL_GET_REDUCER,
    wasRefetched: false
  },
  createdRight: INITIAL_CREATE_REDUCER,
  updateRight: INITIAL_UPDATE_REDUCER,
  deleteRight: INITIAL_DELETE_REDUCER,
  rightSuggestedChanges: INITIAL_GET_REDUCER,
  applyRightSuggestedChanges: INITIAL_CREATE_REDUCER,
  partnerbrainHistory: INITIAL_GET_RESULTS_PAGING_REDUCER,
  rightSocialPosts: INITIAL_GET_RESULTS_REDUCER,
  rightUploadAdData: {
    [FACEBOOK_PLATFORM]: INITIAL_RIGHT_UPLOAD_AD_DATA_REDUCER,
    [GOOGLE_PLATFORM]: INITIAL_RIGHT_UPLOAD_AD_DATA_REDUCER,
    [DV_360_PLATFORM]: INITIAL_RIGHT_UPLOAD_AD_DATA_REDUCER,
    [TIKTOK_PLATFORM]: INITIAL_RIGHT_UPLOAD_AD_DATA_REDUCER
  }
}

export default function rights(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // get rights
    case GET_RIGHTS:
      return update(state, {
        rightsList: {
          $merge: { isLoading: true }
        }
      })
    case GET_RIGHTS_SUCCESS:
      return update(state, {
        rightsList: {
          $merge: {
            ...action.rightsData,
            isLoading: false,
            wasLoaded: true
          }
        }
      })
    case GET_RIGHTS_FAILURE:
      return update(state, {
        rightsList: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_RIGHTS:
      return update(state, {
        rightsList: { $set: initialState.rightsList }
      })

    // get right
    case GET_RIGHT:
      return update(state, {
        right: {
          $merge: {
            isLoading: true,
            // right can be re-fetched (social posts rights summary), so we explicitly set this field
            wasRefetched: false
          }
        }
      })
    case GET_RIGHT_SUCCESS:
      return update(state, {
        right: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            wasRefetched: true,
            data: action.rightData
          }
        }
      })
    case GET_RIGHT_FAILURE:
      return update(state, {
        right: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_RIGHT:
      return update(state, {
        right: {
          $set: initialState.right
        }
      })

    // create right
    case CREATE_RIGHT:
      return update(state, {
        createdRight: {
          $merge: { isLoading: true }
        }
      })
    case CREATE_RIGHT_SUCCESS:
      return update(state, {
        createdRight: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        },
        rightsList: {
          results: {
            $unshift: [action.rightData]
          }
        }
      })
    case CREATE_RIGHT_FAILURE:
      return update(state, {
        createdRight: { $merge: { error: action.error, isLoading: false } }
      })
    case CLEAR_CREATE_RIGHT:
      return update(state, {
        createdRight: { $set: initialState.createdRight }
      })

    // update right
    case UPDATE_RIGHT:
      return update(state, {
        updateRight: {
          $merge: {
            id: action.id,
            isLoading: true
          }
        }
      })
    case UPDATE_RIGHT_SUCCESS:
      return update(state, {
        updateRight: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        },
        rightsList: {
          results: {
            $apply: items => updateItem(items, action.rightData)
          }
        },
        right: {
          $merge: {
            data: action.rightData
          }
        }
      })
    case UPDATE_RIGHT_FAILURE:
      return update(state, {
        updateRight: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_RIGHT:
      return update(state, {
        updateRight: {
          $set: initialState.updateRight
        }
      })

    // delete right
    case DELETE_RIGHT:
      return update(state, {
        deleteRight: {
          $merge: {
            isLoading: true,
            id: action.id
          }
        }
      })
    case DELETE_RIGHT_SUCCESS:
      return update(state, {
        deleteRight: {
          $merge: {
            isLoading: false,
            wasDeleted: true
          }
        },
        rightsList: {
          results: {
            $apply: items => deleteItemById(items, action.id)
          }
        }
      })
    case DELETE_RIGHT_FAILURE:
      return update(state, {
        deleteRight: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DELETE_RIGHT:
      return update(state, {
        deleteRight: { $set: initialState.deleteRight }
      })

    // Get right suggested changes
    case GET_RIGHT_SUGGESTED_CHANGES:
      return update(state, {
        rightSuggestedChanges: { $merge: { isLoading: true } }
      })
    case GET_RIGHT_SUGGESTED_CHANGES_SUCCESS:
      return update(state, {
        rightSuggestedChanges: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_RIGHT_SUGGESTED_CHANGES_FAILURE:
      return update(state, {
        rightSuggestedChanges: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_RIGHT_SUGGESTED_CHANGES:
      return update(state, {
        rightSuggestedChanges: { $set: initialState.rightSuggestedChanges }
      })

    // Apply right suggested changes
    case APPLY_RIGHT_SUGGESTED_CHANGES:
      return update(state, {
        applyRightSuggestedChanges: { $merge: { isLoading: true } }
      })
    case APPLY_RIGHT_SUGGESTED_CHANGES_SUCCESS:
      return update(state, {
        applyRightSuggestedChanges: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        }
      })
    case APPLY_RIGHT_SUGGESTED_CHANGES_FAILURE:
      return update(state, {
        applyRightSuggestedChanges: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_APPLY_RIGHT_SUGGESTED_CHANGES:
      return update(state, {
        applyRightSuggestedChanges: { $set: initialState.applyRightSuggestedChanges }
      })

    // Get partnerbrain history
    case GET_PARTNERBRAIN_HISTORY:
      return update(state, {
        partnerbrainHistory: { $merge: { isLoading: true } }
      })
    case GET_PARTNERBRAIN_HISTORY_SUCCESS:
      return update(state, {
        partnerbrainHistory: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data.results,
            paging: {
              next: action.data.next
            }
          }
        }
      })
    case GET_PARTNERBRAIN_HISTORY_FAILURE:
      return update(state, {
        partnerbrainHistory: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_PARTNERBRAIN_HISTORY:
      return update(state, {
        partnerbrainHistory: { $set: initialState.partnerbrainHistory }
      })

    // Get right social posts
    case GET_RIGHT_SOCIAL_POSTS:
      return update(state, {
        rightSocialPosts: { $merge: { isLoading: true } }
      })
    case GET_RIGHT_SOCIAL_POSTS_SUCCESS:
      return update(state, {
        rightSocialPosts: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_RIGHT_SOCIAL_POSTS_FAILURE:
      return update(state, {
        rightSocialPosts: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_RIGHT_SOCIAL_POSTS:
      return update(state, {
        rightSocialPosts: { $set: initialState.rightSocialPosts }
      })

    // right upload ad data
    case SET_RIGHT_UPLOAD_AD_DATA:
      return update(state, {
        rightUploadAdData: {
          // ad campaign, lineItem and other data to already existed
          $merge: {
            [action.platform]: {
              ...state.rightUploadAdData[action.platform],
              ...action.data
            }
          }
        }
      })
    case CLEAR_RIGHT_UPLOAD_AD_DATA:
      return update(state, {
        // if platform param was provided, clear only specific state
        rightUploadAdData: action.platform
          ? {
              [action.platform]: { $set: initialState.rightUploadAdData[action.platform] }
            }
          : { $set: initialState.rightUploadAdData }
      })
    default:
      return state
  }
}
